import { startUserContext } from './userContext.js';

// Use the same build flag as the existing emergency entry points.
const isEmergencyMode = typeof __EMERGENCY_MODE__ !== 'undefined' && __EMERGENCY_MODE__;
if (!isEmergencyMode) startUserContext(window);
